import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import { surveyBackButtonSx, surveyNavRowSx, surveyNextButtonSx } from '../../styles/surveyExecutionStyles'
import { SurveyNavPreviousIcon } from './SurveyNavPreviousIcon'

interface SurveyNavActionsProps {
  readonly showBack: boolean
  readonly nextLabel?: string
  readonly nextDisabled: boolean
  readonly nextPending: boolean
  readonly onBack: () => void
  readonly onNext: () => void
}

export function SurveyNavActions({
  showBack,
  nextLabel = 'Next',
  nextDisabled,
  nextPending,
  onBack,
  onNext,
}: SurveyNavActionsProps) {
  return (
    <Box sx={surveyNavRowSx} data-testid="survey-nav-actions">
      {showBack ? (
        <Button
          variant="text"
          onClick={onBack}
          disabled={nextPending}
          startIcon={<SurveyNavPreviousIcon />}
          sx={surveyBackButtonSx}
          data-testid="survey-back"
        >
          Previous
        </Button>
      ) : (
        <Box sx={{ minWidth: { xs: 0, sm: '120px' }, display: { xs: 'none', sm: 'block' } }} aria-hidden />
      )}
      <Button
        variant="contained"
        onClick={onNext}
        disabled={nextDisabled || nextPending}
        disableElevation
        sx={surveyNextButtonSx}
        data-testid="survey-next"
      >
        {nextPending ? (
          <CircularProgress size={20} color="inherit" aria-label="Saving answer" />
        ) : (
          nextLabel
        )}
      </Button>
    </Box>
  )
}
